import { AdserverRequestId, CreativeBeaconType } from '../types';
import { dispatchCreativeNotifications } from './creativeNotifications';

export const dispatchImpressionNotifications = (arid: AdserverRequestId) => {
  return dispatchCreativeNotifications({
    arid,
    beaconType: CreativeBeaconType.Impression
  });
};
